import { HandoutCreate } from "./handoutCreate";
import { HandoutEdit } from "./handoutEdit";
import { HandoutList } from "./handoutList";
import { HandoutShow } from "./handoutShow";

export default {
	create: HandoutCreate,
	edit: HandoutEdit,
	list: HandoutList,
	show: HandoutShow,
};
